const DEVICE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop'
}

const BREAKPOINTS = {
    tablet: 990
}

export { DEVICE, BREAKPOINTS }


// WEBPACK FOOTER //
// ./src/constants/device.js